import { Dispatch } from "redux";

export async function dispatchError(dispatch: Dispatch, type: string) {
  await dispatch({
    type,
  });
}
